import {WorkflowActionTarget} from "../_enums/workflow-action-target";
import {TransactionWorkflowSub} from "./transaction-workflow-sub";

export class TransactionWorkflowAction extends TransactionWorkflowSub {
  target: WorkflowActionTarget = WorkflowActionTarget.Printer;
}
